import {
  reReasonTypesConstants 
} from './constants'
import api from './api';
import { defAction } from '../../../helpers/defaultAction';

export const reReasonActions = {
  getReasonTypes,
  getReasonByName,
  createReasonType,
  deleteReasonType,
  updateReasonType,
  restoreReasonType,
  clearReasonType
}

function getReasonTypes(params) {
  return dispatch => {
    dispatch(request())
    
    api.getReasonTypes(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_REQUEST
    } }
    function success(reasonTypes) { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_SUCCESS,
      payload: reasonTypes
    } }
    function failure(error) { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_FAILURE,
      payload: error
    } }
  }
}

function getReasonByName(params) {
  return dispatch => {
    dispatch(request())
    
    api.getReasonByName(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_REQUEST
    } }
    function success(reasonTypes) { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_SUCCESS,
      payload: reasonTypes
    } }
    function failure(error) { return {
      type: reReasonTypesConstants.SEND_REREASONTYPES_FAILURE,
      payload: error
    } }
  }
}

function createReasonType(value) {
  const dispatchObj = {
    constants: reReasonTypesConstants.createReasonType,
    service: { 
      func: api.createReasonType, 
      params: value 
    }
  }
  return defAction(dispatchObj)
}

function deleteReasonType(value) {
  const dispatchObj = {
    constants: reReasonTypesConstants.deleteReasonType,
    service: { 
      func: api.deleteReasonType, 
      params: value 
    }
  }
  return defAction(dispatchObj)
}

function updateReasonType(value) {
  const dispatchObj = {
    constants: reReasonTypesConstants.updateReasonType,
    service: { 
      func: api.updateReasonType, 
      params: value 
    }
  }
  return defAction(dispatchObj)
}

function restoreReasonType(value) {
  const dispatchObj = {
    constants: reReasonTypesConstants.restoreReasonType,
    service: { 
      func: api.restoreReasonType, 
      params: value 
    }
  }
  return defAction(dispatchObj)
}

function clearReasonType() {
  return (dispatch) => dispatch({
    type: reReasonTypesConstants.getReasonTypes.CLEAR
  })
}